<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp10',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-10">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-10-content pointer">
      <div
        v-for="v in moduleOption.list.slice(0, 2)"
        :key="`modules-10-${v.id}`"
        class="item"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        @click="onModuleItem(v)"
      >
        <el-image :src="v.photo | imgPath" alt="activity" class="item-img" fit="cover" />
        <div class="item-right">
          <div class="logo-group">
            <span class="line" />
            <el-image
              :src="require('imgs/modules/party-logo.png')"
              alt="logo"
              class="party-logo"
              fit="cover"
            />
          </div>
          <p class="item-title h-line-2">{{ v.headline || '' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-10-content {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: 100%;
}
.item {
  width: 455px;
  height: 150px;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding-left: 6px;
  box-sizing: border-box;
  .item-img {
    width: 157px;
    height: 138px;
    border-radius: 5px;
  }
  .item-right {
    width: 254px;
    margin-left: 18px;
    .item-title {
      width: 254px;
      font-size: 17px;
      font-weight: 800;
      color: #000;
      line-height: 25px;
      margin-top: 20px;
    }
  }
}
.logo-group {
  width: 244px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .line {
    width: 37px;
    height: 4px;
    background: #E47676;
    border-radius: 3px;
  }
  .party-logo {
    width: 41px;
    height: 43px;
  }
}
</style>
